import { defineFcm } from '../shared/factory';

export const FCM_NEWRELIC_BROWSER_ENABLED = defineFcm('newrelic_browser_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
